import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { FaChevronDown } from "react-icons/fa";
import { ChevronRightIcon } from '@heroicons/react/20/solid';

import photo from '../assets/me.png';

const Intro = () => {
    const { t } = useTranslation();

    const [text, setText] = useState('');
    const [index, setIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [cursor] = useState('_');
    const [typingSpeed] = useState(150);
    const [deletingSpeed] = useState(50);

    useEffect(() => {
        let timer;
        const subtitles = [t('intro.subtitle'), t('intro.subtitle2'), t('intro.subtitle3')];
        if (isDeleting) {
            timer = setInterval(() => {
                setText((prevText) => prevText.slice(0, -1));
                if (text.length === 0) {
                    setIsDeleting(false);
                    setIndex((prevIndex) => (prevIndex + 1) % subtitles.length);
                }
            }, deletingSpeed);
        } else {
            timer = setInterval(() => {
                setText((prevText) => subtitles[index].slice(0, prevText.length + 1));
                if (text.length === subtitles[index].length) {
                    setIsDeleting(true);
                }
            }, typingSpeed);
        }

        return () => clearInterval(timer);
    }, [text, isDeleting, index, typingSpeed, deletingSpeed, t]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const homeLink = document.getElementById('home-link');
                if (homeLink) {
                    homeLink.style.marginTop = entry.isIntersecting ? '-100px' : '';
                    homeLink.style.opacity = entry.isIntersecting ? '0' : '';
                }
            }, { threshold: 0.5 }
        );

        const section = document.getElementById('intro');
        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    return (
        <section id="intro" className="py-32 px-4">
            <div className="max-w-1100 p-6 mx-auto flex flex-col lg:flex-row items-center">
                <div className="lg:w-1/2 mb-8 lg:mb-0">
                    <img
                        src={photo}
                        alt="Eduardo Rafael"
                        className="w-48 h-48 md:w-72 md:h-72 rounded-full object-cover mx-auto"
                    />
                </div>

                <div className="lg:w-1/2 text-center lg:text-left lg:pl-12 lg:pr-8 lg:pt-8 lg:pb-12 flex flex-col gap-8">
                    <h1 className="text-5xl md:text-7xl font-light mb-4">{t('intro.title')}</h1>
                    <h2 className="text-xl mb-4 flex justify-center md:justify-start">
                        <ChevronRightIcon className="w-7 h-7 mr-2 opacity-50" />
                        {text}
                        <span className="animate-pulse">{cursor}</span>
                    </h2>
                    <p className="text-lg font-light mt-8 mb-4 md:mb-8">{t('intro.description')}</p>
                </div>

            </div><p className="motion-safe:animate-bounce text-md font-light text-3xl lg:mt-12 flex justify-center items-center cursor-pointer" onClick={() => document.querySelector('#about').scrollIntoView({ behavior: 'smooth' })}>
                <FaChevronDown />
            </p>
        </section>
    );
};

export default Intro;